import {RemoteWithEntry} from '@module-federation/sdk';
import {log} from '@/helpers/logger';

const createElement = document.createElement;

// This function allows to detect whether styles are leaking from any Module Federation remote,
// by default it's a no-op and needs to be explicitly enabled with environment variable,
// or launched with a global window function
window.federationStylesLeak = function (mode) {
  if (!mode) {
    return;
  }

  if (mode === 'off') {
    document.createElement = createElement;
    return;
  }

  if (mode !== 'warn' && mode !== 'prevent') {
    return;
  }

  // Detection is heuristic-based because it's not possible to cover every style insertion method,
  // it can fire when styles aren't actually leaking or not fire when they do
  // Current approach works consistently as of release/2605-a,
  // but possibly might need to be adjusted with more diverse remote setups
  document.createElement = function (...args: Parameters<typeof createElement>) {
    const element = createElement.call(this, ...args);

    if (element instanceof HTMLStyleElement || element instanceof HTMLLinkElement) {
      const stack = new Error().stack;

      if (!stack?.includes('vite/deps')) {
        const remote = window.__FEDERATION__.__INSTANCES__
          .find((instance) => instance.name === 'careco')?.options.remotes
          .filter((remote): remote is RemoteWithEntry => 'entry' in remote)
          .find((remote) => stack?.includes(new URL(remote.entry).origin))?.name;

        if (remote) {
          log('warn', `Styles are leaking from ${remote}, this needs to be fixed`);

          if (mode === 'prevent') {
            element.setAttribute('media', 'not all');
          }
        }
      }
    }

    return element;
  };
};

window.federationStylesLeak(process.env.REACT_APP_FEDERATION_STYLES_LEAK);
